import { MessagingPlatform } from '@this+that/models';

// GOOGLE_CHAT's disconnect frame reuses the Gmail address as platformAccountId —
// keying by platform keeps that value from ever colliding with a real Gmail removal.
export const buildRemovedEmailAccountKey = (
  platform: MessagingPlatform,
  address: string,
): string => `${platform}:${address}`;

export const pruneExpiredRemovedEmailAccounts = (
  removedEmailAccounts: Record<string, number>,
  now: number,
): Record<string, number> =>
  Object.fromEntries(
    Object.entries(removedEmailAccounts).filter(
      ([, expiresAt]) => expiresAt > now,
    ),
  );

export const isEmailAccountRemoved = (
  removedEmailAccounts: Record<string, number>,
  platform: MessagingPlatform,
  address: string,
  now: number,
): boolean => {
  const expiresAt =
    removedEmailAccounts[buildRemovedEmailAccountKey(platform, address)];
  return expiresAt !== undefined && expiresAt > now;
};

export const hasActiveRemovedEmailAccounts = (
  removedEmailAccounts: Record<string, number>,
  now: number,
): boolean =>
  Object.values(removedEmailAccounts).some((expiresAt) => expiresAt > now);
